export const appsyncConfig = {
  aws_project_region: process.env.REACT_APP_APPSYNC_PROJECT_REGION,
  aws_appsync_graphqlEndpoint: process.env.REACT_APP_APPSYNC_ENDPOINT,
  aws_appsync_region: process.env.REACT_APP_APPSYNC_REGION,
  aws_appsync_authenticationType: process.env.REACT_APP_AUTH_TYPE,
};
